<template>
  <div>
    <div class="top">
      <h3>{{time}}</h3>
      <p>{{today}}</p>
    </div>
    <input type="text" id="idCard" v-model="idcard" />
    <div class="content">
      <div class="des">请在下方证件识读区放置身份证</div>
      <p>
        提示：当取票机发出“
        <span>嘀</span>”的声响后
        请等待
        <span>2秒</span>即可移开身份证
      </p>
    </div>

    <div class="footer">
      <div class="footer-content">
        <div class="footer-tips">下方识读区</div>
        <i class="iconfont iconxiangxia"></i>
        <p>
          <!-- 设备ID：{{deviceId}} -->
          <span class="tel">
            客服电话
            <span>25650850 25650860</span>
          </span>
        </p>
      </div>
    </div>
    <div class="mask" v-if="warn!=''">
      <div class="mask-content">
        <div class="icon"></div>
        <p>{{warn}}</p>
      </div>
    </div>
    <div class="back" @click="goBack">后退</div>
  </div>
</template>

<script>
import { setInterval, clearInterval, setTimeout } from "timers";
export default {
  name: "Take",
  data() {
    return {
      warn: "",
      deviceId: localStorage.deviceNum || "123456789",
      time: "",
      today: "",
      timer: "",
      idcard: ""
    };
  },
  watch: {
    idcard(val) {
      if (val != "") {
        this.getTicket();
      }
    }
  },
  mounted() {
    this.getDay();
    if (this.timer == "") {
      this.timer = setInterval(() => {
        this.getDay();
      }, 10000);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getTicket() {
      this.$api.getTickets(this.idcard).then(res => {
        if (res.status == 1) {
          if (res.data.length > 0) {
            localStorage.order = JSON.stringify(res.data);
            this.$router.push({
              path: "/ticket_detail"
            });
          } else {
            this.warn = "未查询到该证件下的订单信息！";
            setTimeout(() => {
              this.warn = "";
              this.idcard = "";
            }, 1500);
          }
        } else {
          this.warn = res.msg;
          setTimeout(() => {
            this.warn = "";
            this.idcard = "";
          }, 1500);
        }
      });
    },
    getDay() {
      var day = new Date();
      var hours = day.getHours();
      hours = hours < 10 ? "0" + hours : hours;
      var min = day.getMinutes();
      min = min < 10 ? "0" + min : min;
      var month = day.getMonth() + 1;
      var days = day.getDate();
      var week = day.getDay();
      var strWeek = "";
      switch (week) {
        case 0:
          strWeek = "星期日";
          break;
        case 1:
          strWeek = "星期一";
          break;
        case 2:
          strWeek = "星期二";
          break;
        case 3:
          strWeek = "星期三";
          break;
        case 4:
          strWeek = "星期四";
          break;
        case 5:
          strWeek = "星期五";
          break;
        case 6:
          strWeek = "星期六";
          break;
      }
      this.time = hours + ":" + min;
      this.today = month + "月" + days + "日 " + strWeek;
    },

    //查询订单
    getSend() {
      this.$api.TicketInfo(this.qrcode).then(res => {
        if (res.status == 1) {
          this.$router.push("/detail");
        } else {
          this.warn = "您输入的取票码有误!";
          setTimeout(() => {
            this.warn = "";
            this.qrcode = "";
          }, 1500);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 1920px;
  background: url(.././assets/buy_ticket.png) no-repeat top center;
  overflow: hidden;
  padding-bottom: 60px;
  position: relative;
  .top {
    padding: 30px 32px;
    color: #fff;
    height: 564px;
    font-size: 25px;
    h3 {
      font-size: 70px;
      margin: 0;
    }
  }
  .titles {
    font-size: 92px;
    letter-spacing: 3px;
    color: #0c5193;
    text-align: center;
    margin: 131px;
  }
}
#idCard {
   opacity: 0;
  z-index: -1;
  user-select: none;
  position: relative;
}
.content {
  width: 749px;
  height: 736px;
  background: url(.././assets/ticket_get.png) no-repeat;
  background-size: cover;
  margin: 156px auto 0;
  position: relative;
  .des {
    text-align: center;
    color: #aaa;
    font-size: 30px;
    position: absolute;
    position: absolute;
    bottom: 285px;
    left: 50%;
    width: 80%;
    left: 50%;
    transform: translateX(-50%);
  }
  p {
    position: absolute;
    bottom: 68px;
    left: 160px;
    color: #508aab;
    font-size: 30px;
    width: 510px;
    font-weight: 400;
    line-height: 48px;
    text-align: center;
    span {
      font-weight: 600;
    }
  }
}

.tips {
  color: #aaa;
  text-align: center;
  font-size: 26px;
  line-height: 36px;
  margin: 30px auto;
  letter-spacing: 3px;
}
.back {
  width: 213px;
  height: 98px;
  line-height: 98px;
  box-shadow: 0px 4px 13px 0px rgba(185, 32, 80, 0.35);
  border-radius: 49px 0px 0px 49px;
  background: #fff;
  color: #b95020;
  font-size: 30px;
  text-align: center;
  position: fixed;
  bottom: 10%;
  right: 0;
  z-index: 998;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 24px;
  width: 100%;
  background: #005192;
  .footer-content {
    padding: 60px 60px 20px;
  }
  .footer-tips {
    width: 210px;
    height: 210px;
    background: #0c5193;
    color: #fff;
    font-size: 22px;
    text-align: center;
    line-height: 120px;
    border-radius: 50%;
    position: absolute;
    top: -88px;
    left: 80px;
  }
  i {
    font-size: 40px;
    color: #fff;
    position: absolute;
    top: 0px;
    left: 151px;
  }
  p {
    color: #002f6f;
    font-size: 20px;
    overflow: hidden;
    vertical-align: middle;
    .tel {
      float: right;
      color: #fff;
      font-size: 20px;
      display: inline-block;
      vertical-align: bottom;
      span {
        margin-left: 10px;
        font-size: 34px;
        font-weight: 800;
        color: #fff;
      }
    }
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all ease-in-out 300ms;
  .mask-content {
    width: 600px;
    height: 384px;
    background: #fff;
    border-radius: 6px;
    padding: 65px;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .icon {
      width: 102px;
      height: 102px;
      background: url(.././assets/icon.png) no-repeat;
      background-size: cover;
      margin: 0 auto 80px;
    }
    p {
      color: #5c5c5c;
      font-size: 30px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tickettake.vue